import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router'; // Import Router
import { IconComponent } from 'libs/capra/src/lib/icon/icon.component';
import { TeamPlanComponent } from '../team-plan/team-plan.component';
import { FreePlanComponent } from '../free-plan/free-plan.component';
import { EnterprisePlanComponent } from '../enterprise-plan/enterprise-plan.component';
import { BusinessPlanComponent } from '../business-plan/business-plan.component';
import { CalendlyPopupButtonComponent } from '@mode/shared/ui';
import { AccountFacade } from '@mode/accounts/contract';
import { User } from 'libs/shared/contract-common/src/lib/account/user.types';
import { getAppName, MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { FeatureFlagsFacade, FeatureFlag } from '@mode/shared/contract-common';
import { AnalyticsEvent, AnalyticsService, RunMethodType } from '@mode/shared/util-segment';
import { Observable, map, of } from 'rxjs';

@Component({
  selector: 'mode-plan-selection',
  standalone: true,
  imports: [
    CommonModule,
    TeamPlanComponent,
    FreePlanComponent,
    EnterprisePlanComponent,
    BusinessPlanComponent,
    CalendlyPopupButtonComponent,
    IconComponent,
    RouterModule,
  ],
  templateUrl: './plan-selection.component.html',
  styleUrls: ['./plan-selection.component.scss'],
})
export class PlanSelectionComponent implements OnInit {
  readonly appName = getAppName();

  @Input() isUpgradePlansFlow = false;
  @Input() isPrimarySignupFlow = true;
  @Input() isincludePlanTypeFree = false;
  @Input() isincludePlanType = true;

  buttonLabel = 'Start a 14-day trial';
  formAction = '/organizations/new?flow=sign_up';
  routeLink = '/signup/plans/book_call';
  planDetailsVisible = false;
  org: User | undefined;

  features = [
    { name: 'Analysis', class: 'pri-sub-head' },
    { name: 'Visualization Builder', class: '' },
    { name: 'Python & R Notebooks', class: '' },
    { name: 'SQL Editor', class: '' },
    { name: 'Custom HTML Data Viz', class: '' },
    { name: 'Self-service Reporting', class: '' },
    { name: 'Explorations', class: '' },
    { name: 'Calculated Fields', class: '' },
    { name: 'Drilldowns', class: '' },
    { name: 'Filters & Parameters', class: '' },
    { name: 'Collaboration & Curation', class: 'pri-sub-head' },
    { name: 'Users per Workspace', class: '' },
    { name: 'Scheduled Reports', class: '' },
    { name: 'Email & Slack Integration', class: '' },
    { name: 'Reusable Queries', class: '' },
    { name: 'Datasets', class: '' },
    { name: 'Collections', class: '' },
    { name: 'Custom Themes', class: '' },
    { name: 'White-Label Embed', class: '' },
    { name: 'External Sharing', class: '' },
    { name: 'Security & Automation', class: 'pri-sub-head' },
    { name: 'Secure Database Credential Control', class: '' },
    { name: 'Single Sign-on (SSO)', class: '' },
    { name: 'GitHub Sync', class: '' },
    { name: 'Permissioning', class: '' },
    { name: 'SCIM (Okta)', class: '' },
    { name: 'REST APIs', class: '' },
    { name: 'Webhooks', class: '' },
    { name: 'dbt Freshness Sync', class: '' },
    { name: 'dbt Semantic Layer integration', class: '' },
    { name: 'Support', class: 'pri-sub-head' },
    { name: 'Help Site & Developer Portal', class: '' },
    { name: 'Live In-App Chat & Email', class: '' },
    { name: 'Training', class: '' },
    { name: 'Learning Platform', class: '' },
    { name: 'Dedicated Onboarding', class: '' },
    { name: 'Dedicated Success Manager', class: '' },
    { name: 'Discovery Database', class: '' },
    { name: 'Discovery API', class: '' },
    { name: 'Custom Usage Reports', class: '' },
    { name: '', class: 'empty-cell white-background' },
  ];
  planDetails = [
    {
      name: 'Free',
      status: [
        false,
        'Thousands of rows',
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        '-',
        false,
        'Up to 3',
        '-',
        '-',
        '-',
        'Up to 10',
        '-',
        '-',
        '-',
        '-',
        false,
        true,
        'Google SSO',
        '-',
        '-',
        '-',
        '-',
        '-',
        '-',
        '-',
        false,
        true,
        '-',
        '-',
        '-',
        '-',
        '-',
        '-',
        '-',
        '-',
        false,
      ],
    },
    {
      name: 'Team',
      status: [
        false,
        'Millions of rows',
        '+ Edge environment',
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        'Up to 50 (10 included)',
        true,
        true,
        true,
        'Up to 10',
        'Up to 10',
        true,
        'Add-on',
        'Add-on',
        false,
        true,
        '+ Microsoft SSO',
        true,
        true,
        '-',
        '-',
        true,
        '-',
        '-',
        false,
        true,
        'Standard SLA',
        '-',
        'Mode University',
        '-',
        '-',
        '-',
        '-',
        '-',
        false,
      ],
    },
    {
      name: 'Business',
      status: [
        false,
        'Millions of rows',
        '+ Edge environment',
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        'Minimum 5 users',
        true,
        true,
        true,
        true,
        true,
        true,
        'Add-on',
        'Add-on',
        false,
        true,
        '+ SAML SSO',
        true,
        true,
        true,
        'Core API',
        true,
        true,
        true,
        false,
        true,
        'Priority SLA',
        'Live Training',
        'Mode University',
        '-',
        true,
        true,
        '-',
        '-',
        false,
      ],
    },
    {
      name: 'Enterprise',
      status: [
        false,
        'Tens of millions of rows',
        '+ Edge environment',
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        'Minimum 50 users',
        true,
        true,
        true,
        true,
        true,
        true,
        'Add-on',
        'Add-on',
        false,
        true,
        '+ SAML SSO',
        true,
        true,
        true,
        '+ Discovery API',
        true,
        true,
        true,
        false,
        true,
        'First Class SLA',
        'Custom Training',
        'Mode University',
        true,
        true,
        true,
        true,
        true,
        false,
      ],
    },
  ];
  hideFreePlan$: Observable<boolean> = of(false);
  constructor(
    private router: Router,
    private _accountFacade: AccountFacade,
    private _meta: MetaTagsService,
    private featureFlagsFacade: FeatureFlagsFacade,
    private analyticsService: AnalyticsService
  ) {
    const username = this._meta.getTag(MetaTags.CurrentUsername);
    if (username) {
      this._accountFacade.loadCurrentUser(username);
    }
  }

  onButtonClick(planType?: string): void {
    const queryParams: { [key: string]: string } = { flow: 'sign_up' };

    if (planType) {
      queryParams['plan_type'] = planType;
    }
    this.analyticsService.run(RunMethodType.TrackLink, AnalyticsEvent.Name.PlanSelectionMade, {
      orgId: this.org,
      planType: planType,
    });
    this.router.navigate(['/organizations/new'], { queryParams });
  }

  ngOnInit(): void {
    this._accountFacade.user$.subscribe((org) => (this.org = org));
    this.hideFreePlan$ = this.featureFlagsFacade.asObservable(FeatureFlag.HideFreePlanSelection);
  }
  goBack(): void {
    window.history.back();
  }
}
